import { Navigation } from '@dev-spendesk/grapes';
import classNames from 'classnames';
import { type ReactNode } from 'react';

import {
  NavigationLink,
  type NavigationLinkProps,
} from 'src/core/common/components/NavigationLink';

type HeaderWithNavigationProps = {
  children: ReactNode;
  links: NavigationLinkProps[];
  navigationLabel?: string;
  /**
   * On pages where we want to maximise the space available for the content (like bookkeep & reviews),
   * we can set this to true
   **/
  withSmallPagePadding?: boolean;
  rightContent?: ReactNode;
};

export const HeaderWithNavigation = ({
  children,
  links,
  navigationLabel,
  withSmallPagePadding,
  rightContent,
}: HeaderWithNavigationProps) => {
  return (
    <header
      className={classNames(
        'sticky top-0 z-10 bg-background-primary-default',
        withSmallPagePadding ? 'px-24' : 'px-40',
      )}
    >
      <div className="flex items-center justify-between">
        <h1
          className={classNames(
            'pb-24 text-content-primary heading-xl',
            withSmallPagePadding ? 'pt-24' : 'pt-40',
          )}
        >
          {children}
        </h1>
        {rightContent}
      </div>
      <Navigation aria-label={navigationLabel}>
        {links.map((link) => (
          <NavigationLink {...link} key={link.key} />
        ))}
      </Navigation>
    </header>
  );
};
